import { render } from "./SpecializationSection.vue?vue&type=template&id=316c49b8&scoped=true"
import script from "./SpecializationSection.vue?vue&type=script&lang=js"
export * from "./SpecializationSection.vue?vue&type=script&lang=js"

import "./SpecializationSection.vue?vue&type=style&index=0&id=316c49b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316c49b8"]])

export default __exports__